import { FileArrowDownSolid, FileArrowUpSolid } from '@allocab/allocab-icons';

import { InvoiceDownloadButton } from './InvoiceDownloadButton';
import { Invoice } from './types';
import { Label } from '../../components/atomic/Label';
import { Link } from '../../components/atomic/Link';
import { t } from '../../services/translation/translation';
import { formatDateForParisTZ } from '../../utils/date';
import { formatPrice } from '../../utils/price';

type Props = {
  invoice: Invoice;
};

export const InvoiceCard = ({ invoice }: Props) => {
  const amount = invoice.totalTTC * (invoice.type === 'out' && invoice.totalTTC !== 0 ? -1 : 1);

  return (
    <div>
      <div className="max-w-full p-3 bg-white border border-gray-200 rounded-t-lg shadow dark:bg-gray-800 dark:border-gray-700 space-y-4">
        <div className="grid grid-cols-2 ">
          <div className="grid grid-rows-2">
            <Label>{t('common.date')} :</Label>
            <p className="text-gray-600 dark:text-gray-300">
              {formatDateForParisTZ(invoice.creationDate, t('date.date-short'), false)}
            </p>
          </div>
          <div className="grid grid-rows-2 justify-end">
            <Label>
              <div className="flex items-center gap-1">
                {invoice.type === 'in' ? (
                  <FileArrowUpSolid height={16} width={16} className="fill-current" />
                ) : (
                  <FileArrowDownSolid height={16} width={16} className="fill-current" />
                )}
                <p>{t('common.invoice')} n° :</p>
              </div>
            </Label>
            <div className="text-gray-600 dark:text-gray-300">{invoice.invoiceNumber}</div>
          </div>
        </div>
        <div>
          <Label>{t('common.driver')} :</Label>
          <p>{invoice.driverName ? <Link to={`/drivers/${invoice.driverKey}`}>{invoice.driverName}</Link> : '--'}</p>
        </div>
        <div>
          <Label>{t('invoicing-route.ttc-amount')} :</Label>
          <p>
            <span className="font-bold">{formatPrice(amount)}</span>{' '}
            <span className="opacity-50 text-sm">
              {t('invoicing-route.vat-included', { price: formatPrice(invoice.totalTTC - invoice.totalHT) })}
            </span>
          </p>
        </div>
        <div className="">
          <Label>{t('common.type')} :</Label>
          <p className="text-gray-600 dark:text-gray-300">
            <span>{invoice.subject}</span>
          </p>
        </div>
        <div className="">
          <InvoiceDownloadButton invoice={invoice} />
        </div>
      </div>
    </div>
  );
};
